import { useState } from "react";
import { api } from "../data/api";
import Btn from "../components/Btn";
import Logo from "../assets/logo.png";
import LoginBg from "../assets/login_screen.jpg";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  // Forgot-password
  const [mode, setMode] = useState("login"); // "login" | "forgot"
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotMsg, setForgotMsg] = useState(null);
  const [forgotLoading, setForgotLoading] = useState(false);

  const handleSubmit = async () => {
    if (!email.trim() || !password.trim()) {
      setError("Email and password are required");
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const data = await api.auth.login({ email, password });
      // api.auth.login already persists token + user; pass user upward for routing.
      onLogin(data.user || data);
    } catch (e) {
      setError(e.message || "Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSubmit();
  };

  const handleForgotSubmit = async () => {
    if (!forgotEmail.trim()) {
      setForgotMsg({ type: "error", text: "Enter your email address" });
      return;
    }
    setForgotLoading(true);
    setForgotMsg(null);
    try {
      const data = await api.auth.forgotPassword(forgotEmail.trim());
      setForgotMsg({ type: "success", text: data.message || `Password reset link has been sent to ${forgotEmail.trim()}.` });
    } catch (e) {
      setForgotMsg({ type: "success", text: `Password reset link has been sent to ${forgotEmail.trim()}.` });
    } finally {
      setForgotLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "var(--bg)",
        backgroundImage: `url(${LoginBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        alignItems: "center",
        // justifyContent: "center",
        justifyContent: "flex-end",
        paddingRight: "8%",
        fontFamily: "'DM Sans', system-ui, sans-serif",
      }}
    >
      <div
        style={{
          background: "var(--surface)",
          border: "1px solid var(--border)",
          borderRadius: 12,
          padding: "36px 32px",
          width: 380,
          boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
        }}
      >
        {/* Logo + title */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            marginBottom: 28,
          }}
        >
          <div
            style={{
              width: 30,
              height: 30,
              borderRadius: 7,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <img style={{ width: 30, height: 30 }} src={Logo} alt="logo" />
            <span style={{display:"flex", fontSize:12,color: "var(--text)", fontWeight:900}}>DRPL</span>
          </div>
          <span
            style={{
              fontSize: 17,
              fontWeight: 700,
              color: "var(--ink)",
              letterSpacing: "-0.01em",
            }}
          >
            DR Pulse360
          </span>
        </div>

        {/* Error banner */}
        {error && mode === "login" && (
          <div
            style={{
              background: "var(--red-bg)",
              border: "1px solid var(--red-border)",
              borderRadius: 6,
              padding: "9px 12px",
              marginBottom: 16,
              fontSize: 12,
              color: "var(--red)",
            }}
          >
            {error}
          </div>
        )}

        {mode === "forgot" ? (
          <>
            <div style={{ fontSize: 13, color: "var(--text-sub)", marginBottom: 16 }}>
              Enter your email and we'll send you a link to set a new password.
            </div>

            {forgotMsg && (
              <div
                style={{
                  background: forgotMsg.type === "error" ? "var(--red-bg)" : "var(--green-bg,#f0fdf4)",
                  border: `1px solid ${forgotMsg.type === "error" ? "var(--red-border)" : "var(--green-border,#86efac)"}`,
                  borderRadius: 6,
                  padding: "9px 12px",
                  marginBottom: 16,
                  fontSize: 12,
                  color: forgotMsg.type === "error" ? "var(--red)" : "var(--green,#16a34a)",
                }}
              >
                {forgotMsg.text}
              </div>
            )}

            <div style={{ marginBottom: 22 }}>
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: "var(--text-dim)",
                  textTransform: "uppercase",
                  letterSpacing: "0.07em",
                  marginBottom: 5,
                }}
              >
                Email Address
              </div>
              <input
                type="email"
                value={forgotEmail}
                onChange={(e) => setForgotEmail(e.target.value)}
                onKeyDown={(e) => { if (e.key === "Enter") handleForgotSubmit(); }}
                placeholder="you@example.com"
                autoFocus
                style={{
                  width: "100%",
                  background: "var(--surface)",
                  border: "1px solid var(--border)",
                  borderRadius: 6,
                  padding: "9px 11px",
                  fontSize: 13,
                  color: "var(--text)",
                  fontFamily: "inherit",
                  outline: "none",
                  boxSizing: "border-box",
                }}
              />
            </div>

            <div>
              <Btn primary full disabled={forgotLoading} onClick={handleForgotSubmit}>
                {forgotLoading ? "Sending…" : "Send Reset Link"}
              </Btn>
            </div>

            <div style={{ marginTop: 16, textAlign: "center" }}>
              <button
                onClick={() => { setMode("login"); setForgotMsg(null); }}
                style={{ background: "none", border: "none", color: "var(--text-sub)", fontSize: 12, cursor: "pointer", fontFamily: "inherit", textDecoration: "underline" }}
              >
                ← Back to sign in
              </button>
            </div>
          </>
        ) : (
          <>
            {/* Email */}
            <div style={{ marginBottom: 14 }}>
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: "var(--text-dim)",
                  textTransform: "uppercase",
                  letterSpacing: "0.07em",
                  marginBottom: 5,
                }}
              >
                Email Address
              </div>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder="you@example.com"
                autoFocus
                style={{
                  width: "100%",
                  background: "var(--surface)",
                  border: "1px solid var(--border)",
                  borderRadius: 6,
                  padding: "9px 11px",
                  fontSize: 13,
                  color: "var(--text)",
                  fontFamily: "inherit",
                  outline: "none",
                  boxSizing: "border-box",
                  transition: "border-color 0.15s",
                }}
                onFocus={(e) =>
                  (e.target.style.borderColor = "var(--border-strong)")
                }
                onBlur={(e) => (e.target.style.borderColor = "var(--border)")}
              />
            </div>

            {/* Password */}
            <div style={{ marginBottom: 12 }}>
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: "var(--text-dim)",
                  textTransform: "uppercase",
                  letterSpacing: "0.07em",
                  marginBottom: 5,
                }}
              >
                Password
              </div>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder="••••••••"
                style={{
                  width: "100%",
                  background: "var(--surface)",
                  border: "1px solid var(--border)",
                  borderRadius: 6,
                  padding: "9px 11px",
                  fontSize: 13,
                  color: "var(--text)",
                  fontFamily: "inherit",
                  outline: "none",
                  boxSizing: "border-box",
                  transition: "border-color 0.15s",
                }}
                onFocus={(e) =>
                  (e.target.style.borderColor = "var(--border-strong)")
                }
                onBlur={(e) => (e.target.style.borderColor = "var(--border)")}
              />
            </div>

            <div style={{ textAlign: "right", marginBottom: 14 }}>
              <button
                onClick={() => { setMode("forgot"); setError(null); }}
                style={{ background: "none", border: "none", color: "var(--text-sub)", fontSize: 11, cursor: "pointer", fontFamily: "inherit", textDecoration: "underline", padding: 0 }}
              >
                Forgot password?
              </button>
            </div>

            <div>
              <Btn primary full disabled={loading} onClick={handleSubmit}>
                {loading ? "Signing in…" : "Sign In"}
              </Btn>
            </div>

            {/* Role hint */}
            <div
              style={{
                marginTop: 16,
                fontSize: 11,
                color: "var(--text-dim)",
                textAlign: "center",
              }}
            >
              Role is detected automatically from your credentials
            </div>
          </>
        )}
      </div>
    </div>
  );
}
